module.exports = __webpack_public_path__ + "static/media/famale.1f6d8c21.png";